import { ActiveModel, ActiveField } from '@alt-point/active-models/src'
import { StatusInfoOfOrderStatusPublic } from './StatusInfoOfOrderStatusPublic'
import { OrderDeliveryDto } from './OrderDeliveryDto'
import { OrderPaymentDto } from './OrderPaymentDto'
import { OrderPromotionDto } from './OrderPromotionDto'
import { OrderItemDto } from './OrderItemDto'
import { OrderCancelledReason } from './Enums'
/**
* Class OrderDto
*  Информация о заказе
*/
export class OrderDto extends ActiveModel {

  /**
  * id
  * ИД записи в БД<br>  */
  @ActiveField(0)
  id: number = 0


/**
  * created
  * Отметка времени создания<br>
  */
  @ActiveField('')
  created: string = ''


/**
  * updated
  * Отметка времени обновления<br>
  */
  @ActiveField('')
  updated: string = ''


/**
  * deleted
  * Отметка времени удаления<br>
  */
  @ActiveField(null)
  deleted: null | string = null


  /**
  * currentStatus
  * Информация о статусе  */
  @ActiveField({
    factory: [StatusInfoOfOrderStatusPublic, () => StatusInfoOfOrderStatusPublic.create()]
  })
  currentStatus: StatusInfoOfOrderStatusPublic = StatusInfoOfOrderStatusPublic.create()


  /**
  * cancelledReason
  * Известная причина отмены заказа<br>  */
  @ActiveField(undefined)
  cancelledReason: null | OrderCancelledReason = undefined


  /**
  * delivery
  * Информация о доставке<br>  */
  @ActiveField({
    factory: [OrderDeliveryDto, () => OrderDeliveryDto.create()]
  })
  delivery: OrderDeliveryDto = OrderDeliveryDto.create()


  /**
  * payment
  * Информация об оплате<br>  */
  @ActiveField({
    factory: [OrderPaymentDto, () => null]
  })
  payment: null | OrderPaymentDto = null


/**
  * paymentMethodCode
  * Код выбранного способа оплаты из реестра; null у черновиков до выбора<br>и у заказов маркетплейсов. Для способов через шлюз дублирует Domain.Entities.Orders.OrderPayment.MethodCode;<br>у отложенных способов Domain.Entities.Orders.Order.Payment отсутствует — платёж Skuby не проводит.<br>
  */
  @ActiveField(null)
  paymentMethodCode: null | string = null


/**
  * paymentReceivedAt
  * Когда деньги подтверждены: шлюзом (Domain.Entities.Orders.OrderEvent.PaymentConfirmed) или тем, кто принял их<br>при получении (учётная система, оператор, перевозчик). null — заказ ещё не оплачен,<br>независимо от способа оплаты; первая запись Domain.Entities.Orders.Order.PaymentReceipts ставится в тот же момент.<br>
  */
  @ActiveField(null)
  paymentReceivedAt: null | string = null


/**
  * userEmail
  * Email-адрес пользователя (для случаев, когда пользователь аноним).<br>
  */
  @ActiveField(null)
  userEmail: null | string = null


/**
  * userPhone
  * Телефон пользователя (для случаев, когда пользователь аноним). <br><br>Если пользователь аноним, то обязано быть заполнено.<br>
  */
  @ActiveField(null)
  userPhone: null | string = null


/**
  * userFio
  * ФИО контактного лица (для случаев, когда пользователь аноним или профиль пользователя не содержит этой информации). <br><br>Если пользователь аноним, то обязано быть заполнено.<br>
  */
  @ActiveField(null)
  userFio: null | string = null


/**
  * draftTtl
  * Время, до которого можно запустить процесс оплаты заказа в статусе "Ожидает оплаты" (Domain.Entities.Orders.Order.Status=Domain.Entities.Orders.OrderStatus.Calculated)<br>
  */
  @ActiveField('')
  draftTtl: string = ''


  /**
  * discountTotal
  *   */
  @ActiveField()
  discountTotal?: number


  /**
  * payableBeforePoints
  *   */
  @ActiveField()
  payableBeforePoints?: number


  /**
  * payable
  *   */
  @ActiveField()
  payable?: number


/**
  * @property promotions
  * Снимок применённых акций на момент оформления.  */
  @ActiveField({
    factory: [OrderPromotionDto, () => undefined]
  })
  promotions?: Array<OrderPromotionDto>


  /**
  * estimatedLoyaltyAccrual
  * Оценка начисления кэшбэка, если начисление ещё не проведено.  */
  @ActiveField()
  estimatedLoyaltyAccrual?: null | number


/**
  * @property products
  * Информация о продуктах заказа<br>  */
  @ActiveField({
    factory: [OrderItemDto, () => undefined]
  })
  products?: Array<OrderItemDto>


/**
  * @property statusesArchive
  *   */
  @ActiveField({
    factory: [StatusInfoOfOrderStatusPublic, () => []]
  })
  statusesArchive: Array<StatusInfoOfOrderStatusPublic> = []
}
